import * as tslib_1 from "tslib";
var VENDOR_LIST_URL = 'https://ow1.res.office365.com/owamail/vendorlist.json';
var vendorListCache;
export default function fetchVendorList() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response, e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!vendorListCache) return [3 /*break*/, 6];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    return [4 /*yield*/, fetch(VENDOR_LIST_URL)];
                case 2:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 4];
                    return [4 /*yield*/, response.json()];
                case 3:
                    vendorListCache = _a.sent();
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    e_1 = _a.sent();
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/, vendorListCache];
            }
        });
    });
}
//# sourceMappingURL=fetchVendorList.js.map